import { Muted } from './Muted';
import styles from './ui.module.css';

/**
 * Пронумерованные шаги: «как получить доступ». Нажимать в шагах некуда: это
 * рассказ, а не меню.
 *
 * Номер в круге, а не в метке: метка в этом приложении означает свойство вещи
 * («оружие», «дебаф»), а здесь цифра — это порядок, и прямоугольник рядом с
 * настоящими метками читался как ещё одна из них.
 */
export function StepList({ steps }: { steps: readonly { title: string; hint: string }[] }) {
  return (
    <ol className={styles.stepList}>
      {steps.map((step, index) => (
        <li key={step.title} className={styles.step}>
          <span className={styles.stepNumber}>{index + 1}</span>
          <span className={styles.stepBody}>
            <span className={styles.stepTitle}>{step.title}</span>
            <Muted block>{step.hint}</Muted>
          </span>
        </li>
      ))}
    </ol>
  );
}
